import { defineEntity, object, string } from '~/prix'

const enrollmentEad = defineEntity({
  key: 'matricula',
  title: 'EAD Matricula',
  sources: ['oltp', 'olap'],
  entitySchema: 'ead',
  schema: object({
    id: string().label('ID'),
    cpf: string().label('cpf'),
    dataInicio: string().label('Data de início'),
    dataFim: string().label('Data final'),
    dataMatricula: string().label('Data de matrícula'),
    codigoProduto: string().label('Código de produto'),
    codigoSasDisponibilizacao: string().label('Código SAS disponibilização'),
    codigoSasPortifolio: string().label('Código Sas Portfólio'),
    nomeProduto: string().label('Nome do curso'),
    tipoProduto: string().label('Tipo do curso'),
    percentualConclusaoProduto: string().label('Percentual de conclusão do curso'),
  }),
})

export default enrollmentEad
